/**
 * Using a similar approach to the below link to account for users that may have an adblock:
 * https://developers.google.com/analytics/devguides/collection/gtagjs/sending-data#handle_timeouts
 * In other words, ENSURE the callback gets called if an adblock prevents Google Tag Manager from calling the callback.
 */
export default function createCallbackWithTimeout(
    callback: () => void,
    timeout: number
): () => void {
    let called = false;

    // The function that gets called after a timeout, unless invoked already.
    function timeoutFunction(): void {
        if (!called) {
            callback();
            called = true;
        }
    }

    // Set the timeout to call the timeoutFunction
    setTimeout(timeoutFunction, timeout);

    return timeoutFunction;
}
